(function () {
  'use strict';

  /* @ngdoc object
   * @name main.entitats
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.entitats', [
      'ui.router'
    ]);
}());
